import {useMemo, useEffect} from 'react';
import {Column, useTimesheetTableContext} from '../../TimesheetTableContext';
import {useVisibleTimesheetTableColumns} from '../useVisibleTimesheetTableColumns';

type UseTimesheetsInternalTimeTableColumnsProps = {
	isWeekView: boolean;
};

export function useTimesheetsInternalTimeTableColumns({isWeekView}: UseTimesheetsInternalTimeTableColumnsProps): Column[] {
	const {setColumnDefinitions} = useTimesheetTableContext();
	const allInternalTimeColumns = useMemo(
		() => [
			{id: 'switch-task-indicator', visible: true, toggleable: false},
			{id: 'internal-time-name', visible: true, toggleable: false},
			{id: 'hour-inputs-week', visible: isWeekView, toggleable: false},
			{id: 'hour-inputs-day', visible: !isWeekView, toggleable: false},
			{id: 'notes-button', visible: isWeekView, toggleable: false},
			{id: 'notes-input', visible: !isWeekView, toggleable: false},
			{id: 'star', visible: true, toggleable: false},
			{id: 'edit', visible: !isWeekView, toggleable: false},
			{id: 'delete', visible: true, toggleable: false},
		],
		[isWeekView]
	);

	useEffect(() => setColumnDefinitions(allInternalTimeColumns), [allInternalTimeColumns]);

	const visibleInternalTimecolumns = useVisibleTimesheetTableColumns(allInternalTimeColumns);

	return visibleInternalTimecolumns;
}
